import { useEffect, useRef } from 'react';

import { ReactEditor, useSlate } from 'slate-react';

import { cn } from '@/shadcn/lib/utils';

import { MySuperBadPortal } from '@/components/ui/richEditor/richEditor.portal';

export const SubjectAutoComplete = ({ subjects, index }) => {
  const ref = useRef<HTMLDivElement>(null);
  const editor = useSlate();

  useEffect(() => {
    const el = ref.current;
    if (el && subjects?.length > 0 && ref.current) {
      const domRange = ReactEditor.toDOMRange(editor, {
        anchor: { path: [0, 0], offset: 0 },
        focus: { path: [0, 0], offset: 0 }
      });
      const rect = domRange.getBoundingClientRect();
      el.style.top = `${rect.top + window.pageYOffset + 24}px`;
      el.style.left = `${rect.left + window.pageXOffset}px`;
    }
  }, [subjects?.length, editor, index]);

  if (subjects?.length === 0) return null;

  return (
    <MySuperBadPortal>
      <div
        className="-top-2000 -left-2000 absolute z-2 rounded-md border border-border bg-popover p-1 text-popover-foreground text-sm"
        ref={ref}
      >
        {subjects?.map((subject, i) => (
          <div
            className={cn(
              'rounded-sm bg-transparent px-1 py-px',
              i === index && 'bg-accent text-accent-foreground'
            )}
            key={subject}
          >
            {subject}
          </div>
        ))}
      </div>
    </MySuperBadPortal>
  );
};
